// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"Search_searchBox__NeVOY"};